import React, { useRef, useState, useEffect } from 'react';
import {
    View,
    Text,
    StyleSheet,
    Dimensions,
    TouchableOpacity,
    Image,
    Animated,
    KeyboardAvoidingView,
    TextInput,
    Keyboard,
    Platform,
    Linking,
} from 'react-native';
import { BlurView } from 'expo-blur';

import Toast, { useToast } from "react-native-toast-notifications";
import { COLORS, FONTS } from '../../utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { sendProductRequest } from '../apiCall/ProductRequestApiCall';

const { width, height } = Dimensions.get("window");

const ProductRequestModal = ({ isVisible, onClose,callbackFunction }) => {
    const crossCircle = require("../assets/images/crosscircle.png");
    const translateY = useRef(new Animated.Value(800)).current;
    const toast = useToast();

    const notifyMessage = (msg) => {
    toast.show(msg, {
        type: "normal",
        placement: "bottom",
        duration: 1200,
        animationType: "zoom-in",
    });
};

    const [manufacturer, setManufacture] = useState('');
    const [productName, setProductName] = useState('');
    const [description, setDescription] = useState('');
    const [urlLink, setUrlLink] = useState('');
    const [isKeyboardVisible, setKeyboardVisible] = useState(false);

    useEffect(() => {
        const keyboardDidShowListener = Keyboard.addListener(
            'keyboardDidShow',
            () => setKeyboardVisible(true)
        );
        const keyboardDidHideListener = Keyboard.addListener(
            'keyboardDidHide',
            () => setKeyboardVisible(false)
        );
        return () => {
            keyboardDidShowListener.remove();
            keyboardDidHideListener.remove();
        };
    }, []);

    useEffect(() => {
        toggleBottomSheet(isVisible);
    }, [isVisible]);

    const toggleBottomSheet = (show) => {
        Animated.spring(translateY, {
            toValue: show ? 0 : 800,
            useNativeDriver: true,
            duration: 300,
        }).start();
    };

  

    // const handleProductRequest = () => {
    //     if (manufacturer === "") notifyMessage('Please Enter Manufacturer');
    //     else if (productName === "") notifyMessage('Please Enter Product');
    //     else if (description === "") notifyMessage('Please Enter Description');
    //     else {
    //         const email = "products@nutrisearch.ca";
    //         const subject = "Product Request";
    //         const body = `
    //     Product Name: ${productName}
    //     Manufacturer Name: ${manufacturer}
    //     Description: ${description}
    //     Url:${urlLink}
    //   `;
    //         const url = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    //         Linking.openURL(url);
    //         onClose();
    //     }
    // };

    const handleProductRequest = async () => {
    if (!manufacturer.trim()) return notifyMessage('Please Enter Manufacturer');
    if (!productName.trim()) return notifyMessage('Please Enter Product');
    if (!description.trim()) return notifyMessage('Please Enter Description');

    try {
        // get user_id from AsyncStorage
        const user_id = await AsyncStorage.getItem("id");
        if (!user_id) return notifyMessage("User not found");

        // payload
        const payload = {
            manufacturer,
            productName,
            url: urlLink,
            description,
            user_id: parseInt(user_id),
        };

        // API call
        const result = await sendProductRequest(payload);

        if (result?.status) {
            notifyMessage("Product request submitted successfully!");
            onClose();
            // reset inputs
            setManufacture('');
            setProductName('');
            setDescription('');
            setUrlLink('');
        } else {
            notifyMessage("Failed to submit product request.");
        }
    } catch (err) {
        console.error(err);
        notifyMessage("Error submitting request.");
    }
};
    return (
        <>
            {isVisible && (
                <BlurView
                    tint={"dark"}
                    intensity={20}
                    style={styles.blackBlurContainer}
                />
            )}
            <Animated.View style={[styles.bottomSheet, { transform: [{ translateY }] }]}>
                <View style={styles.animatedView}>
                    <Text allowFontScaling={false} style={styles.requestText}>Request</Text>
                    <TouchableOpacity activeOpacity={0.7} onPress={onClose} style={{ height: 35, width: 35, position: "absolute", right: 9, bottom: 12 }}>
                        <Image source={crossCircle} style={{ height: 35, width: 35, resizeMode: "contain" }} />
                    </TouchableOpacity>
                </View>
                <KeyboardAvoidingView style={{ flex: 1 }} behavior={Platform.OS === "ios" ? "padding" : "height"}>
                    <TextInput
                        value={manufacturer}
                        onChangeText={setManufacture}
                        placeholder="Manufacturer"
                        placeholderTextColor={COLORS.primarygraycolor}
                        style={styles.inputView}
                    />
                    <TextInput
                        value={productName}
                        onChangeText={setProductName}
                        placeholder="Product Name"
                        placeholderTextColor={COLORS.primarygraycolor}
                        style={styles.inputproductname}
                    />
                    <TextInput
                        value={urlLink}
                        onChangeText={setUrlLink}
                        placeholder="URL"
                        placeholderTextColor={COLORS.primarygraycolor}
                        style={styles.inputproductname}
                    />
                    <View style={{ height: 160, width: Platform.OS === "web" ? "50%" : "64%", maxWidth: 436, minWidth: 325, borderWidth: 1, borderRadius: 8, paddingRight: Platform.OS === "web" ? 0 : 20, borderColor: COLORS.primarybordercolor, alignSelf: "center", marginTop: 20 }}>
                        <TextInput
                            value={description}
                            onChangeText={setDescription}
                            multiline
                            placeholder="Description"
                            placeholderTextColor={COLORS.primarygraycolor}
                            style={styles.textInput}
                        />
                    </View>
                    <TouchableOpacity onPress={handleProductRequest} style={[styles.submitBtn, { marginBottom: isKeyboardVisible ? 200 : 10 }]}>
                        <Text style={{ fontWeight: "500", fontFamily: FONTS.PoppinsSemiBold, fontSize: 14, textAlign: "center", lineHeight: 21, color: "white" }}>Submit</Text>
                    </TouchableOpacity>
                </KeyboardAvoidingView>
            </Animated.View>
        </>
    );
};

const styles = StyleSheet.create({
    blackBlurContainer: {
        ...StyleSheet.absoluteFillObject, // full screen
        justifyContent: "center",
        zIndex: 1000, // bring on top
    },
    bottomSheet: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: Platform.OS === "ios" ? height - 120 : Platform.OS === "web" ? 600 : "90%",
        backgroundColor: "white",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        elevation: 10, // increase elevation for Android
        zIndex: 1001, // on top of blur
    },
    animatedView: { height: 50, backgroundColor: "white", flexDirection: "row", alignItems: "center", paddingRight: 15, paddingLeft: 15, borderTopRightRadius: 12, justifyContent: "center", borderTopLeftRadius: 12, marginTop: 5 },

    
    requestText: { color: COLORS.primary, fontSize: 24, textAlign: "center", lineHeight: 36, alignSelf: "center", marginTop: 5, fontFamily: "Poppins-SemiBold", fontWeight: Platform.OS === "web" ? "400" : "600" },
    inputView: { width: Platform.OS === "web" ? "50%" : width - 92, marginTop: 25, maxWidth: 436, minWidth: 325, borderWidth: 1, borderRadius: 8, height: 50, paddingLeft: 20, paddingRight: 20, borderColor: COLORS.primarybordercolor, alignSelf: "center" },
    inputproductname: { width: Platform.OS === "web" ? "50%" : width - 92, maxWidth: 436, minWidth: 325, borderWidth: 1, borderRadius: 8, height: 50, paddingLeft: 20, paddingRight: 20, borderColor: COLORS.primarybordercolor, fontFamily: FONTS.PoppinsMedium, alignSelf: "center", marginTop: 20 },
    textInput: { paddingLeft: 20, paddingTop: 10, paddingRight: 20, color: "black", fontFamily: FONTS.PoppinsRegular, fontWeight: "400" },
    submitBtn: { width: Platform.OS === "web" ? "50%" : width - 92, maxWidth: 436, minWidth: 325, borderRadius: 30, height: 50, paddingLeft: 20, paddingRight: 20, alignSelf: "center", marginTop: 20, backgroundColor: COLORS.primary, alignItems: "center", justifyContent: "center" },
});

export default ProductRequestModal;
